<template>
  <transition name="fade">
    <div
      v-show="visible"
      class="ba-fixed ba-inset-0 ba-z-1030 ba-flex ba-justify-center ba-items-center"
    >
      <!-- BACKDROP  ============================== -->
      <div class="ba-absolute ba-inset-0 ba-bg-background-dark ba-opacity-25" />
      <!-- END BACKDROP =========================================================== -->

      <!-- MODAL CONTENT ============================== -->
      <div
        class="ba-relative ba-z-50 ba-flex ba-flex-col ba-w-full ba-max-w-md ba-bg-white ba-rounded"
      >
        <!-- =================== -->
        <header
          class="ba-flex ba-justify-between ba-items-center ba-px-5 ba-py-4 ba-text-white ba-bg-background-dark ba-rounded-t"
        >
          <h4 class="ba-leading-none">Создание документа</h4>
          <button
            type="button"
            title="Закрыть"
            class="ba-px-8 ba--mx-8 ba-py-4 ba--my-4"
            @click="onCloseModal"
          >
            <i class="fal fa-times"></i>
          </button>
        </header>
        <!-- =================== -->

        <div class="ba-p-5">
          <form action="">
            <!-- SELECT -->
            <div class="ba-mb-6">
              <h5
                class="ba-mb-2 ba-font-wellingtons-demibold ba-text-text-black"
              >
                Выберите тип документа
              </h5>
              <DxSelectBox
                v-model:value="selectedValue"
                :items="docTypes"
                display-expr="Title"
                value-expr="Name"
              />
            </div>

            <div class="ba-mb-6">
              <h5
                class="ba-mb-2 ba-font-wellingtons-demibold ba-text-text-black"
              >
                Выберите основной документ
              </h5>
              <DxSelectBox
                v-model:value="selectedMainDocument"
                :items="documentList"
                display-expr="Name"
                value-expr="Link"
              />
            </div>
            <!-- =========================================================== -->

            <!-- CONTROLS -->
            <div class="ba-flex ba-justify-end">
              <button
                type="button"
                class="ba-mr-6 ba-px-5 ba-py-3 ba-text-xs ba-leading-none ba-font-wellingtons-medium ba-text-accent ba-rounded-full ba-select-none ba-opacity-90 hover:ba-opacity-100"
                @click="onCancelButtonClick"
              >
                Отменить
              </button>
              <button
                type="button"
                class="ba-px-5 ba-py-3 ba-text-xs ba-leading-none ba-font-wellingtons-medium ba-text-white ba-bg-accent ba-rounded-full ba-select-none ba-opacity-90 hover:ba-opacity-100"
                @click="onDocumentCreate"
              >
                Создать
              </button>
            </div>
            <!-- =========================================================== -->
          </form>
        </div>
      </div>
      <!-- END MODAL CONTENT ============================== -->
    </div>
  </transition>
</template>

<script>
import { DxSelectBox } from "devextreme-vue/select-box";
import api from "@/api/visary-api";
import fileApi from "@/api/filestorage-api";

export default {
  name: "vis-docmail-modal-design",
  components: {
    DxSelectBox,
  },
  model: {
    prop: "visible",
    event: "toggle",
  },
  props: {
    visible: { type: Boolean, default: false },
    documents: { type: String },
  },
  data() {
    return {
      favorites: [
        "Исходящий договор",
        "Протокол разногласий",
        "Приложение к договору",
      ],
      selectedValue: null,
      selectedMainDocument: null,
      docTypes: [],
      documentList: [],
    };
  },
  watch: {
    async documents(val) {
      let data = (val || "").split(",").filter(function (s) {
        return !!s;
      });
      this.documentList = [];
      for (let i = 0; i < data.length; i++) {
        const info = await fileApi.file.getLinkInfo(data[i]);
        this.documentList.push({ Name: info.Name, Link: data[i] });
      }
    },
  },
  methods: {
    onCancelButtonClick() {
      this.onCloseModal();
    },
    onCloseModal() {
      this.clearSelectedValues();
      this.$emit("toggle", false);
    },
    onDocumentCreate(e) {
      if (this.selectedValue && this.selectedMainDocument) {
        const otherDocs = this.documentList
          .filter((x) => x.Link !== this.selectedMainDocument)
          .map((x) => x.Link)
          .join(",");

        this.$emit("onCreate", {
          type: this.selectedValue,
          mainDocument: this.selectedMainDocument,
          otherDocs: otherDocs,
        });
        this.clearSelectedValues();
      }
    },
    clearSelectedValues() {
      this.selectedMainDocument = null;
      this.selectedValue = null;
    },
  },
  async created() {
    this.docTypes = await api.documentFlow.getDocumentTypesToCreate();
  },
};
</script>

